<template>
  <div>
    Creating a room
  </div>
</template>

<script>
export default {
  name: 'RoomCreateView'
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/RoomCreateView.vue